import type { RouteRecordRaw } from 'vue-router'
import { legacyTenantRedirect, maybeRouteName, tenantScopedRedirect } from './tenantScoped'

const createPortfolioChildren = (withNames: boolean): RouteRecordRaw[] => [
  {
    path: 'alignments',
    ...maybeRouteName(withNames, 'portfolio-alignments'),
    component: () => import('@/views/portfolio/AlignmentList.vue'),
    meta: { permission: 'project:alignment:view' }
  },
  {
    path: 'alignments/:id',
    ...maybeRouteName(withNames, 'portfolio-alignment-detail'),
    component: () => import('@/views/portfolio/AlignmentDetail.vue'),
    meta: { permission: 'project:alignment:view' }
  }
]

const createPortfolioRoute = (path: string, withNames: boolean): RouteRecordRaw => ({
  path,
  component: () => import('@/views/portfolio/PortfolioLayout.vue'),
  redirect: tenantScopedRedirect('/portfolio/alignments'),
  ...(withNames ? {} : { beforeEnter: legacyTenantRedirect }),
  meta: {
    permission: 'project:alignment:view',
    ...(!withNames ? { legacyTenantRedirect: true } : {}),
  },
  children: createPortfolioChildren(withNames)
})

const portfolioRoutes: RouteRecordRaw[] = [
  createPortfolioRoute('t/:tenantCode/portfolio', true),
  createPortfolioRoute('portfolio', false),
]

export default portfolioRoutes
